angular.module('vastdesk').component('forecastBudget', {
  bindings: {
    formName: '@',
    formId: '@',
    budget: '=',
    estimatedCpm: '=',
    estimatedFillRate: '=',
  },
  template: require('../templates/forecastBudget.html'),
  controllerAs: '$forecastBudgetCtrl',
  controller: [function () {
    const self = this;

    this.budgetIsPresent = function () {
      return self.budget && !self.budget._destroy;
    };

    this.budgetIsPersisted = function () {
      return self.budget && typeof self.budget.id !== 'undefined' && self.budget.id !== null;
    };

    this.canAddBudget = function () {
      return !self.budgetIsPresent() || self.budget._destroy;
    };

    this.hasEstimatedCPM = function () {
      return self.budgetIsPresent() && self.budget.budget_metric === 'revenue';
    };

    this.hasEstimatedFillRate = function () {
      return self.budgetIsPresent() && self.budget.budget_metric === 'requests';
    };

    this.addBudget = function () {
      if (!self.budget) {
        self.budget = {
          budget_metric: 'impressions',
          budget_value: null,
          budget_period: 'day',
          budget_pacing: 'smooth',
        };
      }
      self.budget._destroy = false;
    };

    this.removeBudget = function () {
      self.budget._destroy = true;
      if (!self.budgetIsPersisted()) {
        self.budget = null;
      }
    };
  }]
});
